import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import axiosConfig from '../api/axiosConfig';

export default function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('teacherToken'));
  const navigate = useNavigate();

  // Token'ı axios header'a ekle
  useEffect(() => {
    if (token) {
      axiosConfig.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete axiosConfig.defaults.headers.common['Authorization'];
    }
  }, [token]);

  // Sayfa yüklendiğinde token varsa kullanıcı bilgilerini getir
  useEffect(() => {
    const checkAuth = async () => {
      if (token) {
        try {
          // Önce localStorage'dan teacher bilgilerini kontrol et
          const storedTeacherInfo = localStorage.getItem('teacherInfo');
          if (storedTeacherInfo) {
            // Admin tarafından giriş yapılmışsa, kayıtlı bilgileri kullan
            const teacherData = JSON.parse(storedTeacherInfo);
            setUser(teacherData);
          } else {
            // Normal giriş - API'den bilgileri getir
            const response = await axiosConfig.get('/ogretmen/profile');
            setUser(response.data);
          }
        } catch (error) {
          console.error('Auth check failed:', error);
          // localStorage'ı temizle
          localStorage.removeItem('teacherToken');
          localStorage.removeItem('teacherInfo');
          setToken(null);
          setUser(null);
        }
      }
      setLoading(false);
    };

    checkAuth();
  }, [token]);

  // Giriş fonksiyonu - GÜNCELLEME BURADA
  const login = async (email, password) => {
    try {
      const response = await axiosConfig.post('/ogretmen/login', {
        e_posta: email,
        password: password
      });

      console.log('Full response:', response);
      console.log('Response data:', response.data);

      const { token, ogretmen } = response.data;
      
      // Token'ı kaydet
      localStorage.setItem('teacherToken', token);
      setToken(token);
      
      // Kullanıcı bilgilerini kaydet
      setUser(ogretmen);
      
      // Axios header'ı güncelle
      axiosConfig.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      
      return { success: true };
    } catch (error) {
      console.error('Login error:', error);
      return { 
        success: false, 
        message: error.response?.data?.message || 'Giriş başarısız' 
      };
    }
  };

  // Çıkış fonksiyonu
  const logout = async () => {
    try {
      // Admin tarafından giriş yapılmışsa logout API'yi çağırma
      const teacherInfo = localStorage.getItem('teacherInfo');
      if (!teacherInfo) {
        await axiosConfig.post('/ogretmen/logout');
      }
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      // Her durumda local state'i temizle
      localStorage.removeItem('teacherToken');
      localStorage.removeItem('teacherInfo');
      setToken(null);
      setUser(null);
      delete axiosConfig.defaults.headers.common['Authorization'];
      navigate('/teacher/login');
    }
  };

  // Profil güncelleme
  const updateProfile = async (profileData) => {
    try {
      const response = await axiosConfig.put('/ogretmen/update-profile', profileData);
      setUser(response.data.ogretmen);
      return { success: true, message: response.data.message };
    } catch (error) {
      console.error('Update profile error:', error);
      return { 
        success: false, 
        message: error.response?.data?.message || 'Güncelleme başarısız' 
      };
    }
  };

  // Şifre değiştirme
  const changePassword = async (currentPassword, newPassword) => {
    try {
      const response = await axiosConfig.put('/ogretmen/change-password', {
        currentPassword,
        newPassword
      });
      return { success: true, message: response.data.message };
    } catch (error) {
      console.error('Change password error:', error);
      return { 
        success: false, 
        message: error.response?.data?.message || 'Şifre değiştirme başarısız' 
      };
    }
  };

  const value = {
    user,
    token,
    loading,
    login,
    logout,
    updateProfile,
    changePassword,
    isAuthenticated: !!user
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}